import type { AxiosResponse } from 'axios';
import api from 'src/services/api';
import * as utils from './apiUtils';
import type {
  DetectionsIndexParams,
  DetectionsGetImageParams,
} from 'src/models/apis/extLandAiDetections/extLandAiDetectionsRequest';
import {
  type DetectionsIndexResponse,
  toDetection,
} from 'src/models/apis/extLandAiDetections/extLandAiDetectionsResponse';
import type { Detection } from 'src/models/extLandAiDetections';

export default {
  async index(params: DetectionsIndexParams): Promise<Detection[]> {
    const response = await api.get<DetectionsIndexResponse>(utils.getApiUrl('/ext/land-ai/detections'), { params });
    return response.data.map(toDetection);
  },
  getImage(params: DetectionsGetImageParams): Promise<AxiosResponse<Blob>> {
    return api.get(utils.getApiUrl(`/ext/land-ai/image`), {
      params,
      responseType: 'blob',
    });
  },
};
